import React, { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import NaptarNezet from './NaptarNezetMain';
import CustomTooltip from '../../../../components/Tooltip/CustomTooltip.js';
import getTooltip from './../NaptarTooltips.js';

class NaptarNezetBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Naptár
              <CustomTooltip text={getTooltip('naptar')} id="naptarTT" />
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {(this.props.globals.hasRole(['NAPTAR_NAPTAR']))
                    ? (
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle('1'); }}
                        >
                        Naptár
                        </NavLink>
                      </NavItem>
                    )
                    : <div />}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {(this.props.globals.hasRole(['NAPTAR_NAPTAR']))
                    ? (
                      <TabPane tabId="1">
                        <NaptarNezet {...this.props} globals={this.props.globals} activeTab={this.state.activeTab} />
                      </TabPane>
                    )
                    : <div />}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NaptarNezetBase;
